import { render } from "./GuideIcon.vue?vue&type=template&id=c4ad57c8&scoped=true"
import script from "./GuideIcon.vue?vue&type=script&lang=js"
export * from "./GuideIcon.vue?vue&type=script&lang=js"

import "./GuideIcon.vue?vue&type=style&index=0&id=c4ad57c8&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ad57c8"]])

export default __exports__